import { render, staticRenderFns } from "./pointsProduct.vue?vue&type=template&id=afed2074&scoped=true"
import script from "./pointsProduct.vue?vue&type=script&lang=js"
export * from "./pointsProduct.vue?vue&type=script&lang=js"
import style0 from "./pointsProduct.vue?vue&type=style&index=0&id=afed2074&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afed2074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afed2074')) {
      api.createRecord('afed2074', component.options)
    } else {
      api.reload('afed2074', component.options)
    }
    module.hot.accept("./pointsProduct.vue?vue&type=template&id=afed2074&scoped=true", function () {
      api.rerender('afed2074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/memberCenter/views/activity_management/components/pointsProduct.vue"
export default component.exports